import { jsx, jsxs } from "react/jsx-runtime";
function NoMessage() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 120 120",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.29596 12C7.63911 12 6.29596 13.3431 6.29596 15V62.3058H6.2959V84.3088C6.2959 86.3817 8.86152 87.3518 10.233 85.7974L24.5675 69.5516H83.8683C85.5251 69.5516 86.8683 68.2085 86.8683 66.5516V15C86.8683 13.3431 85.5251 12 83.8683 12H9.29596Z",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "22.7393",
                y: "43.2422",
                width: "24.665",
                height: "3.28867",
                rx: "1.64433",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M111 54.6083C112.657 54.6083 114 55.9514 114 57.6083V94.0723V95.7166V105.713C114 107.744 111.521 108.735 110.121 107.264L99.1227 95.7166H54.5154C52.8585 95.7166 51.5154 94.3734 51.5154 92.7166V57.6083C51.5154 55.9514 52.8585 54.6083 54.5154 54.6083H111Z",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "67.5",
                y: "63.75",
                width: "3.75",
                height: "12",
                rx: "1.875",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "81",
                y: "63.75",
                width: "3.75",
                height: "12",
                rx: "1.875",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M74.7432 84.8225C77.8514 86.1739 85.1221 87.0929 89.3385 79.9574",
                stroke: "#AFB9C9",
                strokeWidth: "3.375",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "22.7393",
                y: "31.7318",
                width: "37.8196",
                height: "3.28867",
                rx: "1.64433",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M86.8681 28.4433L70.4248 12V25.4433C70.4248 27.1002 71.768 28.4433 73.4248 28.4433H86.8681Z",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M70.4248 11.9999L86.8681 28.4432V11.9999H70.4248Z",
                fill: "white"
            })
        ]
    });
}
export { NoMessage as default };
